/*
 * Input Quantity directive
 * Version 1.0.0
 * Octave
 * Modified from <https://github.com/Firestitch/angular-counter>.
 **/
(function () {
  'use strict';

  angular
  .module('component.input.quantity', [])

  .component('inputQuantity', {
    require: {
      productCtrl: '?^^productDetail'
    },
    bindings: {
      id: '<?idProduct',
      min: '<?',
      step: '<?',
      quantity: '<?',
      width: '<?',
      size: '@?',
      btnClass: '@?',
      fieldTabindex: '@',
      keyEnter: '&?',
      action: '&?'
    },
    templateUrl: 'component.input-quantity.tpl',

    /* @ngInject */
    controller: ["$scope", "LoadService", function ($scope, LoadService) {
      var ctrl = this;

      ctrl.$onInit = function () {
        ctrl.js = $(document.body).data('js-components');
        LoadService.getService('AsyncComponentsService', { ctrl: ctrl, scope: $scope }, 'initInputQuantity');
      };
    }]
  });

})();
